import Api from './Api'
import AnalyticsService from './AnalyticsService'

export default {
  getContent (sortBy, category, offset, time, gameName, dur, typeId, secCat, w, creator, tabGroup, fromDate, toDate) {
    return Api().get('clips',
      {
        withCredentials: true,
        params: {
          sortBy: sortBy,
          category: category,
          offset: offset,
          time: time,
          gameName: gameName,
          typeId: typeId,
          secCat: secCat,
          w: w,
          creator: creator,
          tabGroup: tabGroup,
          fromDate: fromDate,
          toDate: toDate
        }
      }
    )
  },

  getUserContent (sortBy, userId, offset, time, dur, typeId, favorite) {
    return Api().get('user/clips',
      {
        withCredentials: true,
        params: {
          sortBy: sortBy,
          userId: userId,
          offset: offset,
          time: time,
          typeId: typeId,
          favorite: favorite
        }
      }
    )
  },

  uploadContent (uploadURL, videoCategory, gameName, secCat, title, context, tabGroup, santa) {
    AnalyticsService.trackContentSubmission('clip')
    return Api().post('clips/submit',
      {
        uploadURL: uploadURL,
        videoCategory: videoCategory,
        gameName: gameName,
        secCat: secCat,
        title: title,
        context: context,
        tabGroup: tabGroup,
        santa: santa
      },
      { withCredentials: true }
    )
  },

  deleteContent (postId) {
    return Api().delete(`clips/delete/${postId}`,
      {
        withCredentials: true
      })
  },

  markWatched (postId, gameId, hide, value) {
    return Api().post('clips/watched',
      {
        postId: postId,
        gameId: gameId,
        hide: hide,
        value: value
      },
      {
        withCredentials: true
      }
    )
  },

  upvote (postId) {
    AnalyticsService.trackVote('clip', 'upvote')
    return Api().post('clips/upvote',
      {
        postId: postId
      },
      { withCredentials: true }
    )
  },

  // game id is needed to check mod status
  superUpvote (postId, gameId) {
    AnalyticsService.trackVote('clip', 'upvote')
    return Api().post('clips/superupvote',
      {
        postId: postId,
        game_id: gameId
      },
      { withCredentials: true }
    )
  },

  downvote (postId) {
    AnalyticsService.trackVote('clip', 'downvote')
    return Api().post('clips/downvote',
      {
        postId: postId
      },
      { withCredentials: true }
    )
  },

  // game id is needed to check mod status
  superDownvote (postId, gameId) {
    AnalyticsService.trackVote('clip', 'downvote')
    return Api().post('clips/superdownvote',
      {
        postId: postId,
        game_id: gameId
      },
      { withCredentials: true }
    )
  },

  favoriteContent (postId) {
    AnalyticsService.trackFavorite('clip')
    return Api().post('clips/favorite',
      {
        postId: postId
      },
      { withCredentials: true }
    )
  }
}
